module.exports = __webpack_public_path__ + "img/nav-right-search-below-kia.b5d278d8.png";